import * as React from 'react';
import { storeDispatch } from '../state/Store';
import { generateClassName } from '../utils';
import * as Actions from '../state/actions';
import { IosCloseButton } from './iOSCloseButton';
import { useMobileLayout } from 'hooks/useMobileLayout';

interface Props {
  title?: string;
  opaque?: boolean;
  fullWidth?: boolean;
  onScroll?: (event: React.UIEvent<HTMLDivElement>) => void;
  titleControls?: React.ReactNode;
  alignTop?: boolean;
  onClose?: () => void;
  hideCloseButton?: boolean;
}

export const Overlay: React.FunctionComponent<Props> = props => {
  const isWebApp = useMobileLayout();

  const didClickClose = React.useCallback(() => {
    if (props.onClose !== undefined) {
      props.onClose();
    } else {
      storeDispatch(Actions.closeModal());
    }
  }, [props.onClose]);

  return (
    <div
      className={generateClassName('overlay', {
        opaque: props.opaque,
        fullWidth: props.fullWidth,
        fullHeight: true
      })}
    >
      {props.hideCloseButton !== true &&
        (isWebApp ? (
          <IosCloseButton onClick={didClickClose} />
        ) : (
          <button
            className="tertiary close close--figma"
            style={{ zIndex: 1 }}
            onClick={didClickClose}
          />
        ))}
      <div className="overlay-content" onScroll={props.onScroll}>
        {!props.alignTop && <div style={{ flex: 1 }} />}
        {props.title && !isWebApp && (
          <header>
            <h1>{props.title}</h1>
            {props.titleControls && (
              <div className="overlay-title-controls">
                {props.titleControls}
              </div>
            )}
          </header>
        )}
        {props.children}
        <div style={{ flex: 1 }} />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Overlay.tsx